(function () {

	"use strict";
	angular
		.module('harriApp')
		.directive('hWeekDatePicker', ['$timeout', function ($timeout) {
			return {
				templateUrl: '../scripts/global-directives/html/h_week_date_picker.ng.html',
				restrict: 'E',
				scope: {
					weekRange: '=?ngModel',
					onWeekSelected: '&',
					startDayOfWeek: '=?',
                    datadogActionName: '<?',
                    dateContainer: '<',
                    placement:'<',
                    endDate: '=',
				},
				link: function (scope, element, attrs) {

					//a function to generate the week range
					var getWeekRange = function (date, selectedDay) {
						return {
							from: getWeekStart(date, scope.startDayOfWeek || "MON"),
							to: getWeekStart(date, scope.startDayOfWeek || "MON").add(6, 'd'),
                            selected_date: (selectedDay)? moment(selectedDay) : null
						};
					}

                    scope.weekRange = scope.weekRange || getWeekRange(moment());
                    scope.date = new Date(scope.weekRange.from);

					//check if the week is in currentMonth
					scope.isWeekInOneMonth = function () {
						if (scope.weekRange && scope.weekRange.from && scope.weekRange.to
							&& scope.weekRange.from.isSame(scope.weekRange.to, 'month')) {
							return true;
						}
						return false;
					}

					//Move week to next
					scope.addWeek = function () {
                        const originalRange = {
                            ...(scope.weekRange ?? {}),
                            from: scope.weekRange?.from?.clone(),
                            to: scope.weekRange?.to?.clone(),
                        };
						scope.weekRange.from.add(1, 'w');
						scope.weekRange.to.add(1, 'w');
                        scope.date = new Date(scope.weekRange.from);
						//Fire select event
						scope.onWeekSelected({weekRange: getWeekRange(moment(scope.weekRange.from), scope.weekRange.from), originalRange});
					}

					//Move week to prev
					scope.subtractWeek = function () {
                        const originalRange = {
                            ...(scope.weekRange ?? {}),
                            from: scope.weekRange?.from?.clone(),
                            to: scope.weekRange?.to?.clone(),
                        };
						scope.weekRange.from.subtract(1, 'w');
						scope.weekRange.to.subtract(1, 'w');
                        scope.date = new Date(scope.weekRange.from);
						//Fire select event
						scope.onWeekSelected({weekRange: getWeekRange(moment(scope.weekRange.from), scope.weekRange.from), originalRange});
					}

                    //Check if the endDate is within the selected week
                    scope.isEndDateInSelectedWeek = function () {
                        if (scope.endDate) {
                            let endMoment = moment(scope.endDate);
                            return endMoment.isBetween(scope.weekRange.from, scope.weekRange.to, 'day', '[]');
                        }
                        return false;
                    };

					/**
					 * Open the date picker when input is pressed
					 */
					scope.openDatepicker = function () {
						element.find('input[name="selectedDate"]').focus();
					}

					/**
					 * update weeks on date change
					 */
                    scope.changeDatePicker = function () {
                        const originalRange = {
                            ...(scope.weekRange ?? {}),
                            from: scope.weekRange?.from?.clone(),
                            to: scope.weekRange?.to?.clone(),
                        };
                        scope.weekRange = getWeekRange(moment(scope.date), scope.date);
                        //Fire select event
                        scope.onWeekSelected({weekRange: scope.weekRange, originalRange});
                    };

					/**
					 * update week when the startDayOfWeek change
					 */
					scope.$watch('startDayOfWeek', function (newVal, oldVal) {
                        if (newVal) {
                            const originalRange = {
                                ...(scope.weekRange ?? {}),
                                from: scope.weekRange?.from?.clone(),
                                to: scope.weekRange?.to?.clone(),
                            };
                            scope.weekRange = getWeekRange(scope.weekRange.from, scope.weekRange.selected_date);
                            scope.startDayOfWeek = newVal;
                            setTimeout(function () {
                                scope.onWeekSelected({weekRange: scope.weekRange, originalRange});
                            }, 1);
                        }
					});

                    scope.onBlur = function (event) {
                        scope.$emit('weekDatePickerInputBlured', event);
                    };

                    scope.onFocus = function(event) {
                        scope.$emit('weekDatePickerInputFocused', event);
                    };

				}
			};
		}])

})();
